/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 10:08:41
 * @LastEditTime: 2022-03-01 15:20:42
 * @LastEditors: wangshengqiang
 * @Description: 利益演示模块
 */
import React, { useEffect, useState } from 'react';
import { Tabs } from 'zarm';
import _ from 'lodash';
import cn from 'classnames';
import { isPreviewMode } from '@/utils/tool';
import { getState, dispatch } from '@/store';
import request from '@/utils/request';
import { getFetchBaseData } from '@/utils/utils';
import SingleAlert from '@/components/SingleAlert/singleAlert';
import ZaToast from '@/components/ZaToast/index.js';
import { ModuleContext } from '../BaseModule';
import './index.less';
import previewData from './previewData';
export default function BenefitDemonstration(props = {}) {
  var _formState$trailEleme;

  const {
    id,
    label,
    children,
    attrs,
    form,
    Render,
    component
  } = props;
  const {
    componentName
  } = attrs || {};
  const [isCanRequestBenfactor, setIsCanRequestBenfactor] = useState(true);
  const formState = getState('formValues');
  const [benefitTable, setBenefitTable] = useState(isPreviewMode() ? previewData : []);
  const [current, setCurrent] = useState(0); // 查看所有的试算因子是否填写完成
  // 利益演算接口 入参跟试算一样

  const doBenefitDemo = async () => {
    const data = getFetchBaseData();
    const opts = {
      method: 'POST',
      data
    };
    const res = (await request('/v1/insure/benefitCalculate', opts)) || {};
    const {
      code,
      message,
      result
    } = res;

    if (Number(code)) {
      const codeList = ['20000', '20019'];

      if (codeList.includes(code)) {
        const modal = SingleAlert({
          title: '温馨提示',
          content: message,
          onCancel: () => {
            modal.hide();
          }
        });
        return;
      }

      ZaToast.show(message);
      return;
    }

    return result;
  };

  const formValuesStr = form.getFieldsValue(undefined, fieldMeta => {
    return fieldMeta.isBenefitFactor;
  });

  const isBenefitFactor = async () => {
    setIsCanRequestBenfactor(true); // getBenfitFactor(); // 手动展示利益演示副标题

    const data = (await doBenefitDemo()) || []; //  data: Array<{datas, titles, benefitFactors, comparisonChartAttr}>;

    const _data = [...data]; // dispatch({
    //   benefitTable: _data,
    // });

    setBenefitTable(_data);
  };

  useEffect(() => {
    if (isPreviewMode()) return;
    const names = form.getFieldsName(meta => meta.isBenefitFactor);
    form.validateFields(names, {
      noUpdate: true
    }).then(val => {
      isBenefitFactor();
    }).catch(() => {
      setIsCanRequestBenfactor(false);
    });
  }, [JSON.stringify(formValuesStr)]);
  const cls = cn({
    [component]: true
  }); // 取被保人列表

  const insuredList = ((_formState$trailEleme = formState.trailElement) === null || _formState$trailEleme === void 0 ? void 0 : _formState$trailEleme[1]) || [];
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cls
  }, /*#__PURE__*/React.createElement(ModuleContext.Provider, {
    value: {
      benefitTable: benefitTable[current]
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "insured-tab-container"
  }, (insuredList === null || insuredList === void 0 ? void 0 : insuredList.length) > 1 && insuredList.map((insurer, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: `insured-tab ${current === index ? 'active-tab' : ''}`,
      onClick: () => {
        setCurrent(index);
      }
    }, /*#__PURE__*/React.createElement("span", null, insurer.name || `被保人${index + 1}`));
  })), /*#__PURE__*/React.createElement(Render, {
    components: children
  })));
}